import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {environment} from '../../environments/environment';
import 'rxjs/add/operator/map';

@Injectable()
export class PaypalService {

    constructor(private http: Http) {
    }

    unsubscribe() {
        return this.http.get(`${environment.baseURL}/api/paypal/unsubscribe`)
            .map((res: Response) => {
                return res.json();
            });
    }

    getAdvancedButton(singlePayment: any) {
        return this.http.get(`${environment.baseURL}/api/paypal/subscribe/advanced?singlePayment=${singlePayment}`)
            .map((res: Response) => {
                return res.json();
            });
    }

    getPremiumButton(singlePayment: any) {
        return this.http.get(`${environment.baseURL}/api/paypal/subscribe/premium?singlePayment=${singlePayment}`)
            .map((res: Response) => {
                return res.json();
            });
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/services/paypal.service.ts